import React from 'react'

const ServiceIconSeven = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" fill="none">
            <g clipPath="url(#clip0_418_20)">
                <path fillRule="evenodd" clipRule="evenodd" d="M28.7999 0H89.5499V60.75H85.5882V30.375C85.5882 15.7875 73.7626 3.96196 59.1749 3.96196C44.5874 3.96196 32.7619 15.7874 32.7619 30.375V60.75H28.7999V0ZM61.2 29.25V90H0.449951L0.449956 29.25H4.41191V59.625C4.41191 74.2126 16.2374 86.0382 30.825 86.0382C45.4126 86.0382 57.2381 74.2126 57.2381 59.625V29.25H61.2Z" fill="url(#paint0_linear_418_20)" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_418_20" x1="12.7012" y1="8.55" x2="67.5067" y2="77.9904" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFD9A0" />
                    <stop offset="1" stopColor="#FFF5F1" />
                </linearGradient>
                <clipPath id="clip0_418_20">
                    <rect width="90" height="90" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default ServiceIconSeven